const ChecksSortingSelection = [
    {
        id: 'registrationID-hl',
        order: 'hl',
        icon: 'fas fa-arrow-down',
        property: 'registrationID'
    },{
        id: 'registrationID-lh',
        order: 'lh',
        icon: 'fas fa-arrow-up',
        property: 'registrationID'
    },{
        id: 'systemID-hl',
        order: 'hl',
        icon: 'fas fa-arrow-down',
        property: 'systemID'
    },{
        id: 'systemID-lh',
        order: 'lh',
        icon: 'fas fa-arrow-up',
        property: 'systemID'
    },{
        id: 'department-hl',
        order: 'hl',
        icon: 'fas fa-arrow-down',
        property: 'departmentEl'
    },{
        id: 'department-lh',
        order: 'lh',
        icon: 'fas fa-arrow-up',
        property: 'departmentEl'
    }, {
        id: 'severity-hl',
        order: 'hl',
        icon: 'fas fa-arrow-down',
        property: 'severity'
    },{
        id: 'severity-lh',
        order: 'lh',
        icon: 'fas fa-arrow-up',
        property: 'severity'
    }   
]

const RecordSortingSelection = [
    {
        id: 'errorCode-hl',
        order: 'hl',
        icon: 'fas fa-arrow-down',
        property: 'errorCode'
    },{
        id: 'errorCode-lh',
        order: 'lh',
        icon: 'fas fa-arrow-up',
        property: 'errorCode'
    },{
        id: 'errorType-hl',
        order: 'hl',
        icon: 'fas fa-arrow-down',
        property: 'errorType'
    },{
        id: 'errorType-lh',
        order: 'lh',
        icon: 'fas fa-arrow-up',
        property: 'errorType'
    },{
        id: 'severity-hl',
        order: 'hl',
        icon: 'fas fa-arrow-down',
        property: 'errorSeverity'
    },{
        id: 'severity-lh',
        order: 'lh',
        icon: 'fas fa-arrow-up',
        property: 'errorSeverity'
    }
]

const FieldSelection = [
    {
        id: 'systemID'
    }, {
        id: 'registrationID'
    },{
        id: 'ssn'
    }, {
        id: 'ssnCountry'
    }, {
        id: 'tin'
    }, {
        id: 'tinCountry'
    }, {
        id: 'lastNameEn'
    }, {
        id: 'lastNameEl'
    }, {
        id: 'firstNameEn'
    }, {
        id: 'firstNameEl'
    }, {
        id: 'fatherFirstNameEn'
    }, {
        id: 'fatherFirstNameEl'
    }, {
        id: 'motherFirstNameEn'
    }, {
        id: 'motherFirstNameEl'
    }, {
        id: 'birthdate'
    }, {
        id: 'birthyear'
    }, {
        id: 'bdate_istrue',
    }, {
        id: 'gender'
    }, { 
        id: 'citizenship'
    }, {
        id: 'mobilePhone'
    }, {
        id: 'extEmail'
    }, {
        id: 'enrollmentStatus'
    }, {
        id: 'enrollmentType'
    }, {
        id: 'enrollmentStatusDate'
    },  {
        id: 'loginName'
    }, {
        id: 'accountStatus'
    }
]

const ErrorTypeSelection = [
    {
        id: 'trimming',
    }, {
        id: 'null-value',
    }, {
        id: 'invalid-value',
    }, {
        id: 'missmatch',
    }, {
        id: 'normalization'
    }, {
        id: 'invalid-format'
    } 
] 

const SeveritySelection = [
    {
        id: 1,
    }, {
        id: 2,
    }, {
        id: 3,
    }, {
        id: 4,
    }, {
        id: 5,
    }
]

const ErrorCodeSelection = [
   {
       id: 1
   }, {
       id: 2
   }, {
       id: 3
   }, {
       id: 4
   }, {
       id: 5
   }, {
       id: 6
   }, {
       id: 7
   }, {
       id: 301
   }, {
       id: 302
   }, {
       id: 303
   }, {
       id: 304
   }, {
       id: 601
   }, {
       id: 602
   }, {
       id: 603
   }, {
       id: 901
   }, {
       id: 902
   }, {
       id: 903
   }, {
       id: 904
   }, {
       id: 905
   }, {
       id: 906
   }, {
       id: 1001
   }, {
       id: 1002
   }, {
       id: 1101
   }, {
       id: 1201
   }, {
       id: 1203
   }, {
       id: 1204
   }, {
       id: 1205
   }, {
       id: 1206
   }, {
       id: 1207
   }, {
       id: 1208
   }, {
       id: 1209
   }, {
       id: 1210
   }, {
       id: 1211
   }, {
       id: 1212
   }, {
       id: 1501
   }, {
       id: 1502
   }, {
       id: 1503
   }, {
       id: 1505
   }, {
       id: 1801
   }, {
       id: 1802
   }, {
       id: 1803
   }, {
       id: 1804
   }, {
       id: 1805
   }, {
       id: 1807
   }, {
       id: 1808
   }, {
       id: 1809
   }, {
       id: 2101
   }, {
       id: 2401
   }, {
       id: 2701
   }, {
       id: 2702
   }, {
       id: 3001
   }, {
       id: 3002
   }, {
       id: 3301
   }, {
       id: 3302
   }, {
       id: 3303
   }, {
       id: 3304
   }, {
       id: 3401
   }, {
       id: 3402
   }, {
       id: 3403
   }, {
       id: 3404
   }, {
       id: 3405
   }, {
       id: 3406
   }, {
       id: 3407
   }, {
       id: 3408
   }, {
       id: 3601
   }, {
       id: 3602
   },  {
       id: 3603
   }, {
       id: 3604
   }, {
       id: 3801
   }, {
       id: 3802
   }, {
       id: 3803
   }, {
       id: 3804
   }, {
       id: 4001
   }, {
       id: 4101
   }, {
       id: 4201
   }, {
       id: 4202
   }, {
       id: 4203
   }, {
       id: 4204
   }, {
       id: 4205
   }, {
       id: 4206
   }, {
       id: 4207
   }, {
       id: 4208
   }, {
       id: 4209
   }, {
       id: 4501
   }, {
       id: 4502
   }, {
       id: 4503
   }, {
       id: 4504
   }, {
       id: 4505
   }, {
       id: 4801
   }, {
       id: 5101
   }, {
       id: 5102
   }, {
       id: 5103
   }, {
       id: 5104
   }, {
       id: 5105
   }, {
       id: 5106
   }, {
       id: 5107
   }, {
       id: 5108
   }, {
       id: 5109
   }, {
       id: 5110
   }, {
       id: 5111
   }, {
       id: 5112
   }, {
       id: 5113
   }, {
       id: 5114
   }, {
       id: 5115
   }, {
       id: 5116
   }, {
       id: 5117
   }, {
       id: 5118
   }, {
       id: 5119
   }, {
       id: 5120
   }, {
       id: 5121
   }, {
       id: 5122
   }, {
       id: 5123
   }, {
       id: 5124
   }, {
       id: 5125
   }, {
       id: 5126
   }, {
       id: 5127
   }, {
       id: 5128
   }, {
       id: 5129
   }, {
       id: 5130
   }, {
       id: 5131
   }, {
       id: 5132
   }, {
       id: 5133
   }, {
       id: 5134
   }, {
       id: 5135
   }, {
       id: 5401
   }, {
       id: 5402
   },
]

const EnrollmentType = [
    'undergraduate',
    'postgraduate',
    'doctoral'
]

const EnrollmentStatus = [
    'active',
    'inactive',
    'interim',
    'discontinued',
    'graduated'
]

const AttendanceType = [
    'part-time',
    'full-time'
]

const AccountStatus = [
    'enabled',
    'disabled'
]

export  { ChecksSortingSelection, 
          RecordSortingSelection,
          FieldSelection,
          ErrorTypeSelection,
          ErrorCodeSelection,
          SeveritySelection,
          EnrollmentType,
          EnrollmentStatus,
          AttendanceType,
          AccountStatus
        }



// WEBPACK FOOTER //
// ./src/results/FiltersConfig.js